import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "../../styles/Clients.scss";
import { baseURL } from "../BaseUrl";
// import { Form } from "react-bootstrap";
// import { travelizeAuth } from "../HeaderAuthentication";
import GoogleMapAddressModel from "../GoogleMapAddressModel";
import Select from "react-select";
import Geocode from "react-geocode";
import { React_Google_API_Key } from "../../GoogleApiKey";
import { LoadScript } from "@react-google-maps/api";
import AlertModel from "../AlertModel";
Geocode.setApiKey(React_Google_API_Key);

function AddClientModel(props) {
  const [userList, setUserList] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [clientName, setClientName] = useState("");
  const [contPersonName, setContPersonName] = useState("");
  const [mobileNum, setMobileNum] = useState("");
  const [email, setEmail] = useState("");
  const [landLine, setLandLine] = useState("");
  const [address, setAddress] = useState("");
  const [enableStatus, setEnableStatus] = useState(1);
  const [country, setCountry] = useState(0);
  const [zoneId, setZoneId] = useState(0);
  const [stateId, setStateId] = useState(0);
  const [cityId, setCityId] = useState(0);
  const [pinCode, setPinCode] = useState("");
  const [location, setLocation] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [googleMapsModel, setGoogleMapsModel] = useState(false);
  const [latLan, setLatLan] = useState({
    lat: null,
    lng: null,
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    alertType: "",
    message: "",
  });
  const [fieldReq, setFieldReq] = useState(false);

  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };

  useEffect(() => {
    if (latLan.lat == null && latLan.lng == null) {
      getLocation();
    }
  }, []);

  const getLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported for your browser");
    } else {

      navigator.geolocation.getCurrentPosition((position) => {
        setLatLan({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  };

  const closeAlertModel = () => {
    setShowAlert(!showAlert);
  };

  let cntyList = [{ value: 1, label: "India" }];

  useEffect(() => {
    fetchDropdownData();
    setLocation("");
    setCountryList(cntyList);
  }, []);

  const fetchDropdownData = () => {
    let requestOptionZone = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/Zone/GetZones`, requestOptionZone)
      .then((res) => res.json())
      .then((res) => {

        if (res.success) {
          setZoneList(
            res.result.map((data) => {
              return { value: data.zoneId, label: data.zoneName };
            })
          );
        } else {
          setZoneList([]);
        }
      });
  };

  useEffect(() => {
    fetchDropdownByZone();
  }, [zoneId, stateId]);

  const fetchDropdownByZone = () => {
    let requestOptionZone = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/Zone/GetStates?ZoneId=${zoneId}`, requestOptionZone)
      .then((res) => res.json())
      .then((res) => {

        if (res.success) {
          setStateList(
            res.result.map((data) => {
              return { value: data.stateId, label: data.stateName };
            })
          );
        } else {
          setStateList([]);
        }
      });
    fetch(`${baseURL}/api/Zone/GetCities?StateId=${stateId}`, requestOptionZone)
      .then((res) => res.json())
      .then((res) => {

        if (res.success) {
          setCityList(
            res.result.map((data) => {
              return { value: data.cityId, label: data.cityName };
            })
          );
        } else {
          setCityList([]);
        }
      });
  };

  const openGoogleMaps = () => {
    setGoogleMapsModel(!googleMapsModel);
    setAddress("");
  };

  // VALIDATIONS START
  const checkValidation = (e) => {
    e.preventDefault();
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setMobileNum(e.target.value);
      setAlertMessage({ alertType: "fails", message: "" });
    } else {
      setShowAlert(true);
      setAlertMessage({ alertType: "fails", message: "Accept only numbers" });
    }
  };
  // VALIDATIONS END

  //  ADDING CLIENT START
  const addClientDetails = (e) => {
    e.preventDefault();
    if (
      clientName !== "" &&
      contPersonName !== "" &&
      mobileNum.length === 10 &&
      location !== "" &&
      country !== 0 &&
      zoneId !== 0 &&
      stateId !== 0
    ) {
      const clientDetails = {
        client: {
          clientID: 0,
          clientName: clientName,
          mobile: JSON.parse(mobileNum),
          enabledStatus: enableStatus,
          clientLoc: {
            latitude: JSON.stringify(latLan.lat),
            longitude: JSON.stringify(latLan.lng),
            location: location,
          },
          email: email,
          contactPersonName: contPersonName,
          landline: landLine,
          countryID: JSON.parse(country),
          zoneID: JSON.parse(zoneId),
          stateID: JSON.parse(stateId),
          cityID: JSON.parse(cityId),
          pincode: pinCode,
        },
        // clientMapping: userMapList,     /* Mapping will be done base on Zone */
      };
      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: travelizeAuth,
        body: JSON.stringify(clientDetails),
      };
      fetch(`${baseURL}/api/Client/AddClient`, requestOption)
        .then((res) => res.json())
        .then((res) => {

          if (res.success) {
            setShowAlert(true);
            setAlertMessage({
              alertType: "success",
              message: res.message,
            });
            setTimeout(() => {
              props.handleClose();
              setLocation("");
              setZoneId(0);
              setStateId(0);
              setCityId(0);
            }, 2000);
            props.fetchClientDetails();
          } else {
            setShowAlert(true);
            setAlertMessage({
              alertType: "fails",
              message: res.errorMessage,
            });
          }
        });
    } else {
      setFieldReq(true);
      setAlertMessage({
        alertType: "fails",
        message: "Required !",
      });
    }
  };
  //  ADDING CLIENT END

  // GOOGLE MAPS LOCATION START

  useEffect(() => {
    if (searchVal) {
      Geocode.fromAddress(searchVal).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;

          setLatLan({
            lat: lat,
            lng: lng,
          });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }, [searchVal]);

  const onMarkerDragEnd = (e) => {
    setLatLan({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
  };

  const searchLocation = (event) => {
    setSearchVal(event.target.value);
  };

  useEffect(() => {
    if (latLan) {
      Geocode.fromLatLng(latLan.lat, latLan.lng).then(
        (response) => {
          const address = response.results[0].formatted_address;

          setAddress(address);
          setLocation(address);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      addressFromGoogle();
    }
  }, [latLan]);

  const addressFromGoogle = () => {
    openGoogleMaps();
  };

  // GOOGLE MAPS LOCATION END

  return (
    <div>
      <Modal
        show={props.addClientmodelShow}
        onHide={props.handleClose}
        className="main_model add-edit-clients-model"
      >
        <div className="add-edit-client-heading">
          <h6 className="add-edit-client-head">ADD COMPANY</h6>
          <i
            className="fa fa-times"
            onClick={() => {
              props.handleClose();
              setLocation("");
            }}
          />
        </div>
        <form onSubmit={addClientDetails}>
          <div className="add-edit-client">
            <div className="company-name">
              <div className="row">
                <div className="col-md-6 mb-2">
                  <input
                    type="text"
                    className="form-control form add-client-input"
                    id="exampleFormControlInput1"
                    placeholder="Company Name"
                    onChange={(e) => setClientName(e.target.value)}
                    required
                    autoComplete="off"
                  />
                  {fieldReq && clientName === "" ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {alertMessage.message}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-2">
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control form add-client-input"
                    id="exampleFormControlInput1"
                    placeholder="Contact Person Name"
                    onChange={(e) => setContPersonName(e.target.value)}
                  />
                  {fieldReq && contPersonName === "" ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {alertMessage.message}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control form add-client-input"
                    id="exampleFormControlInput1"
                    placeholder="Mobile Number"
                    maxLength={10}
                    onChange={(e) => checkValidation(e)}
                  />
                  {fieldReq && mobileNum.length !== 10 ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {`${alertMessage.message} - 10 Numbers`}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-2">
                  <input
                    type="email"
                    autoComplete="off"
                    className="form-control form add-client-input"
                    id="exampleFormControlInput1"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                  // required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <input
                    type="number"
                    autoComplete="off"
                    className="form-control form add-client-input"
                    id="exampleFormControlInput1"
                    placeholder="Landline"
                    onChange={(e) => setLandLine(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <Select
                    className="react-select-container-list model-select"
                    classNamePrefix="react-select-list"
                    options={countryList}
                    placeholder="Select Country"
                    value={countryList.value}
                    onInputChange={countryList.label}
                    onChange={(data) => setCountry(data.value)}
                    isSearchable={true}
                  />
                  {fieldReq && country === 0 ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {alertMessage.message}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <Select
                    className="select-add-user-model"
                    options={zoneList}
                    placeholder="Select Zone"
                    value={zoneList.value}
                    onInputChange={zoneList.label}
                    onChange={(data) => setZoneId(data.value)}
                    isSearchable={true}
                  />
                  {fieldReq && zoneId === 0 ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {alertMessage.message}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-2">
                  <Select
                    className="select-add-user-model"
                    options={stateList}
                    placeholder="Select State"
                    value={stateList.value}
                    onInputChange={stateList.label}
                    onChange={(data) => setStateId(data.value)}
                    isSearchable={true}
                  />
                  {fieldReq && stateId === 0 ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {alertMessage.message}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <Select
                    className="select-add-user-model"
                    options={cityList}
                    placeholder="Select State"
                    value={cityList.value}
                    onInputChange={cityList.label}
                    onChange={(data) => setCityId(data.value)}
                    isSearchable={true}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <input
                    type="number"
                    autoComplete="off"
                    className="form-control form add-client-input"
                    id="exampleFormControlInput1"
                    placeholder="PinCode"
                    onChange={(e) => setPinCode(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="mb-2 client-location-by-map">
                  <textarea
                    rows="3"
                    cols="20"
                    name="usrtxt"
                    wrap="hard"
                    className="form-control form add-client-input location"
                    id="exampleFormControlInput1"
                    placeholder="Street Address/House No./Locality"
                    value={location}
                    readOnly={true}
                    required
                  // onChange={(e) => setLocation(e)}
                  />

                  <i
                    className="bi bi-geo-alt"
                    title="Google Location"
                    onClick={openGoogleMaps}
                  />
                </div>
                {fieldReq && location === "" ? (
                  <small
                    id={`Error${alertMessage.alertType}`}
                    className="form-text text-muted "
                  >
                    {alertMessage.message}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="mt-2">
                <span className="enable-status d-flex">
                  <h6>Enable</h6>
                  <span className="enable-radio d-flex">
                    <div className="form-check enable-radio-status">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        checked={enableStatus == 1}
                        onChange={() => setEnableStatus(1)}
                      />
                      <label
                        className="form-check-label"
                        for="flexRadioDefault1"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check enable-radio-status">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        checked={enableStatus == 0}
                        onChange={() => setEnableStatus(0)}
                      />
                      <label
                        className="form-check-label"
                        for="flexRadioDefault2"
                      >
                        No
                      </label>
                    </div>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="btns-save-cancel">
            <div className="user-save-button">
              <button
                // onClick={addClientDetails}
                type="submit"
                className="btn btn-save-up"
              >
                Save
              </button>
            </div>
            <div className="user-cancel-button">
              <button
                onClick={() => {
                  props.handleClose();
                  setLocation("");
                }}
                type="button"
                className="btn btn-cancel"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Modal>
      {googleMapsModel ? (
        // <LoadScript googleMapsApiKey={React_Google_API_Key}>
        <GoogleMapAddressModel
          googleMapsModel={googleMapsModel}
          addressFromGoogle={addressFromGoogle}
          openGoogleMaps={openGoogleMaps}
          latLan={latLan}
          searchLocation={searchLocation}
          searchVal={searchVal}
          onMarkerDragEnd={onMarkerDragEnd}
          address={address}
        />
      ) : (
        // </LoadScript>
        ""
      )}
      <>
        {showAlert ? (
          <AlertModel
            showAlert={showAlert}
            alertMessage={alertMessage}
            closeAlertModel={closeAlertModel}
          />
        ) : (
          ""
        )}
      </>
    </div>
  );
}

export default AddClientModel;
